<template>
    <div>

        <div class="card abtg__default-card abtg__default-card-border abtg__air20 ">
            <div class="card-head">
                <header class="abtg__color-black-label">{{$t('operation.title_current_operation')}}
                    {{filterLabel}}
                    <span class="abtg__focus-title">&nbsp;</span>
                </header>
                <div class="abtg__header_popover"></div>
                <div class="tools"></div>
            </div>
            <div class="card-body ">

                <div class="table-responsive">

                    <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded abtg__table-noborder"
                           style="min-height:140px;">
                        <thead>
                        <tr class="d-flex">
                            <th class="text-left col-1">N.</th>
                            <th class="mdl-data-table__cell--non-numeric text-left col-1 align-middle">


                                <span class="abtg__text-abtg">Città</span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric text-left col-2 align-middle">


                                <span class="abtg__text-abtg">Indirizzo</span>
                            </th>

                            <th class="mdl-data-table__cell--non-numeric text-left col-2 align-middle">


                                <span class="abtg__text-abtg">Data vendita</span>
                            </th>

                            <th class="mdl-data-table__cell--non-numeric text-left col-1  align-middle">
                                <span class="abtg__text-abtg">Base Asta</span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric text-left col-2  align-middle">
                                <span class="abtg__text-abtg">Offerta Minima</span>
                            </th>

                            <th class="mdl-data-table__cell--non-numeric text-left col-1  align-middle">
                                <span class="abtg__text-abtg">Rialzo Minimo</span>
                            </th>

                            <th class="2"></th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="(u, index) in auctionListColored"
                            class="d-flex">

                            <td class="col-1 text-center">
                                {{index + 1}}
                            </td>
                            <td class="col-1 text-center">
                                {{u.city}}
                            </td>
                            <td class="col-2 abtg-ellipsis "  >
                                <i class="fas fa-circle" style="color:green"></i>&nbsp;<a :href="u.link" target="_blank" style="text-decoration:underline;color:#337ab7">{{u.indirizzo}}</a>
                            </td>
                            <td class="col-2 abtg-ellipsis">
                                {{u.data_asta}}
                            </td>


                            <td class="col-1 abtg-ellipsis">{{u.base_asta}}</td>
                            <td class="col-2">
                                {{u.offerta_minima}}
                            </td>
                            <td class="col-1">{{u.rialzo_minimo}}</td>
                            <td class="align-top col-2">
                                <a
                                        class="dropdown-item"
                                        style="margin-bottom:-15px !important;"
                                        @click="createOperation({id: u.id})">
                                    <i class="fas fa-calculator  "></i>&nbsp; Conto Economico
                                </a>&nbsp;&nbsp;
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapState, mapMutations, mapGetters} from 'vuex';
    export default {
        props: ['content'],
        data(){
            return {
                // filter: 1,
                  filterLabel: 'in analisi',
                // activeClosedLink: null,
                // activeInProgressLink: null,
                // activeAnalysisLink: null,
                // show: true,
            }
        },
        created(){
            this.auctionListByColor();
        },
        computed: {
            ...mapState('n_auction', [ 'auctionListColored']),
        },
        methods: {
            ...mapMutations('n_auction', ['SET_DATA']),
            ...mapActions('n_auction', ['auctionListByColor', 'createOperation']),
        }
    }
</script>